import { OrderInfo, OrderInfoContact } from "../model/OrderInfo/OrderInformation";
import { isBusinessOrderInfo, isCustomerOrderInfo, isMaritimeOrderInfo } from "../model/OrderInfo/OrderInformationTypeGuards";

/**
 * 注文情報から依頼者の連絡先リスト（氏名 + mailaddress + tel）を取得します。
 * Business/Customer の場合は依頼者1件を返します。
 * Maritime の場合は supplyHeadquartersInfo と supplySourceUnitInfo の両方を依頼者として扱い、2件を返します。
 */
export function getRequesterContactListFromOrderInfo(orderInfo: OrderInfo): OrderInfoContact[] {
    const requesterContactList: OrderInfoContact[] = new Array();

    if (isBusinessOrderInfo(orderInfo) || isCustomerOrderInfo(orderInfo)) {
        requesterContactList.push({
            firstname: orderInfo.requester?.firstname,
            lastname: orderInfo.requester?.lastname,
            mailaddress: orderInfo.requester?.mailaddress?.trim(),
            tel: orderInfo.requester?.tel,
        });
    } else if (isMaritimeOrderInfo(orderInfo)) {
        requesterContactList.push({
            firstname: orderInfo.requester?.supplyHeadquartersInfo.firstname,
            lastname: orderInfo.requester?.supplyHeadquartersInfo.lastname,
            mailaddress: orderInfo.requester?.supplyHeadquartersInfo.mailaddress?.trim(),
            tel: orderInfo.requester?.supplyHeadquartersInfo.tel,
        });
        requesterContactList.push({
            firstname: orderInfo.requester?.supplySourceUnitInfo.firstname,
            lastname: orderInfo.requester?.supplySourceUnitInfo.lastname,
            mailaddress: orderInfo.requester?.supplySourceUnitInfo.mailaddress?.trim(),
            tel: orderInfo.requester?.supplySourceUnitInfo.tel,
        });
    } else {
        throw new Error("invalid OrderInfo Type");
    };

    return requesterContactList;
}

/**
 * 注文情報から依頼者の連絡先（氏名 + mailaddress + tel）を取得します。
 * Maritimeの場合は supplyHeadquartersInfo を依頼者として扱います。
 */
export function getRequesterContactFromOrderInfo(orderInfo: OrderInfo): OrderInfoContact {
    if (isBusinessOrderInfo(orderInfo) || isCustomerOrderInfo(orderInfo)) {
        return {
            firstname: orderInfo.requester?.firstname,
            lastname: orderInfo.requester?.lastname,
            mailaddress: orderInfo.requester?.mailaddress?.trim(),
            tel: orderInfo.requester?.tel,
        };
    } else if (isMaritimeOrderInfo(orderInfo)) {
        return {
            firstname: orderInfo.requester?.supplyHeadquartersInfo.firstname,
            lastname: orderInfo.requester?.supplyHeadquartersInfo.lastname,
            mailaddress: orderInfo.requester?.supplyHeadquartersInfo.mailaddress?.trim(),
            tel: orderInfo.requester?.supplyHeadquartersInfo.tel,
        };
    } else {
        throw new Error("invalid OrderInfo Type");
    };
}

/**
 * 注文情報から配送先の連絡先（氏名 + mailaddress + tel）を取得します。
 * Maritimeの場合は transportRequestUnit を配送先として扱います。
 */
export function getDestinationContactFromOrderInfo(orderInfo: OrderInfo): OrderInfoContact {

    if (isBusinessOrderInfo(orderInfo) || isCustomerOrderInfo(orderInfo)) {
        return {
            firstname: orderInfo.destination?.firstname,
            lastname: orderInfo.destination?.lastname,
            mailaddress: orderInfo.destination?.mailaddress,
            tel: orderInfo.destination?.tel,
        };
    } else if (isMaritimeOrderInfo(orderInfo)) {
        return {
            firstname: orderInfo.destination?.transportRequestUnit?.firstname,
            lastname: orderInfo.destination?.transportRequestUnit?.lastname,
            mailaddress: orderInfo.destination?.transportRequestUnit?.mailaddress,
            tel: orderInfo.destination?.transportRequestUnit?.tel,
        };
    } else {
        throw new Error("invalid OrderInfo Type");
    };
}

